import { createUseStyles, useTheme } from 'react-jss';
import { Colors, Theme } from '@app/theme';
import {
  LabeledIconChip,
  useProfileCompletion,
  useParticipantDisplayName,
  ParticipantLogo,
} from '@app/core';
import { Participant } from '@app/api';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles<string, {}, any>((theme: Theme) => ({
  container: {
    width: '100%',
    padding: [theme.marginBase * 3, theme.marginBase * 2],
    backgroundColor: theme.colors.white,
    boxShadow: theme.boxShadow.mobile,
    borderRadius: [0, 0, theme.borderRadius.large, theme.borderRadius.large],
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase * 2,
    textTransform: 'capitalize',
    marginBottom: theme.marginBase * 5,

    [theme.media.largeScreen]: {
      borderRadius: theme.borderRadius.large,
      padding: [theme.marginBase * 3, theme.marginBase * 3],
    },
  },
  name: {
    ...theme.fonts.h4,
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase,
  },
}));

interface Props {
  participant: Participant;
}

export const ProfileHeader = ({ participant }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();
  const completion = useProfileCompletion();
  const name = useParticipantDisplayName(participant);
  const globalPercentage = completion?.GLOBAL.percentage;
  const textProfileCompletion =
    globalPercentage === 100
      ? t('home.profileCompletion.complete')
      : t('home.profileCompletion.incomplete');
  const colorProfileCompletion: Colors =
    globalPercentage === 100 ? 'green' : 'red';

  return (
    <div className={classes.container}>
      <ParticipantLogo user={participant} />
      <div className={classes.textContainer}>
        <h1 className={classes.name}>{name}</h1>
        <LabeledIconChip
          chipLabel={textProfileCompletion}
          labelColor={colorProfileCompletion}
        />
      </div>
    </div>
  );
};
